exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (c) 2014-2023 Comparatio USA  LLC. <https://www.comparatio.com>\n */\n.ellipsed-text {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap; }\n.wrap {\n  white-space: pre-wrap; }\n#searchTooltip {\n  position: absolute;\n  left: 41%;\n  top: 11%;\n  width: 20%;\n  z-index: 100;\n  color: #FFFFFF;\n  background-color: #333333;\n  padding: 15px;\n  border-radius: 5px; }\n#searchTooltip span {\n    position: absolute;\n    top: 12%;\n    left: -4%;\n    color: #333333; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/transactions/transactions-inventory-download/transactions-inventory-download.component.scss
// module id = ../../../../../angular/app/views/transactions/transactions-inventory-download/transactions-inventory-download.component.scss
// module chunks = main